import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { ActivatedRoute, Router } from '@angular/router';
import { FormGroup, FormBuilder, Validators, FormGroupDirective } from '@angular/forms';
import { OfficerSearchService } from './officer-search.service';
import { vovSharedService } from '../shared/services/vov-shared.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ExcelService } from '../village-staff/excel.service';
import * as moment from 'moment';

// export interface Element {
//   date: any;
//   time: any;
//   streetNo: any;
//   action: Action;
//   user: User;
//   plateNo:any;
//   actionId: any
//   address: Address;

// }
// export interface Action{
//   id:any,
//   action:any
// }
// export interface User{
//   id:any,
//   userName:any
//   password
// }

@Component({
  selector: 'app-officer-details',
  templateUrl: './officer-search-details.component.html',
  styleUrls: ['./officer-search-details.component.scss']
})
export class OfficerSearchDetailsComponent implements OnInit {
  dataSource: MatTableDataSource<any>;
  dataSourcePermit: MatTableDataSource<any>;
  @ViewChild(MatPaginator) permitPaginator: MatPaginator;
  public displayedPermitColumns = [];
  public displayedColumns = [];
  @ViewChild(MatPaginator) paginator: MatPaginator;
  // @ViewChild(MatPaginator) waiverPaginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  // @ViewChild(MatSort) waiverSort: MatSort;

  public enforcementData: any;

  public searchResult: boolean = false;
  public isVillageStaff: boolean;
  public headerName: string;
  searchForm: FormGroup;
  enforcementForm: FormGroup;
  public permitMessage: any;
  public valid: boolean = false;
  public validWaiver: boolean = false;
  public validPermit: boolean = false;
  public actions: any;
  public streets: any;
  private currentUserId: any
  public states: any;
  public streetNumbers: any;
  public enforcement = [];
  public vehicleData: any
  public todayDate: any;
  public btndisabled: boolean = false;
  public messageWithDate: any;
  @ViewChild(FormGroupDirective) formGroupDirective: FormGroupDirective;

  constructor(
    private activeRouter: ActivatedRoute,
    private formBuilder: FormBuilder,
    private officerSearchSearch: OfficerSearchService,
    private vovSharedService: vovSharedService,
    private _snackBar: MatSnackBar,
    private router: Router,
    private excelService: ExcelService,

  ) {
    history.pushState(null, null, location.href);
    window.onpopstate = function () {
      history.go(1);
    }
  }

  ngOnInit(): void {
    this.searchForm = this.formBuilder.group({
      plateNo: ['', Validators.required],
      stateId: ['', Validators.required],
    });

    this.enforcementForm = this.formBuilder.group({
      actionId: ['', Validators.required],
      streetId: ['', Validators.required],
      // streetNoId: ['', Validators.required],
      streetNumber: ['', Validators.required],
      note: [''],
    });

    this.vovSharedService.fetchAllViolationActions().subscribe((res) => {
      this.actions = res.actions.sort((a, b) => a.index - b.index);
    })

    this.vovSharedService.fetchAllStreets().subscribe((res) => {

      this.streets = res.streetsList;
      this.streets.sort((a, b) => a.street.localeCompare(b.street));
    })

    const currentUser = localStorage.getItem("currentUser");
    this.currentUserId = JSON.parse(currentUser).id;

    this.vovSharedService.fetchAllStates().subscribe((res) => {
      this.states = res.statesList;

      const toSelect = this.states.sort((a, b) => a.state.localeCompare(b.state)).filter(s => s.state == 'IL')
      if (toSelect) {
        this.searchForm.get("stateId").patchValue(toSelect[0].id);
      }
      let temStates = res.statesList;
      let result = [];
      result.push(temStates.find(f => f.state == 'IL'));
      result.push(temStates.find(f => f.state == 'WI'));
      temStates = temStates.filter(f => f.state != 'IL' && f.state != 'WI');
      temStates.forEach(element => {
        result.push(element)
      });
      this.states = result;
      //  const toSelect = this.states.filter(s => s.state == 'IL');
      //   if (toSelect) {
      //     this.searchForm.get("stateId").patchValue(toSelect[0].id);
      //   }
      // const withWI = this.states.filter(s => s.state == 'WI');
      // const withoutWI = this.states.filter(s => s.state != 'WI');
      // // withoutWI.push(1, withWI)
      // withoutWI.splice(1, 1, withWI)
      // this.states = result;
    });
    // this.vovSharedService.fetchAllEnforcement().subscribe((res)=>{
    //   this.enforcements = res.enforcements;
    // });

    // this.enforcementForm.controls['actionId'].valueChanges.subscribe(
    //   (actionId: any) => {
    //     if (actionId) {
    //       this.vovSharedService.getStreetNumbersByStreetId(streetId).subscribe((res) => {
    //         this.streetNumbers = res.streetNoList;
    //       });
    //     }
    //   }
    // );


    this.enforcementForm.controls['streetId'].valueChanges.subscribe(
      (streetId: any) => {
        if (streetId) {
          this.vovSharedService.getStreetNumbersByStreetId(streetId).subscribe((res) => {
            this.streetNumbers = res.streetNoList;
          });
        }
      }
    );

    this.searchForm.controls['plateNo'].valueChanges.subscribe(
      (value: any) => {
        if (value == '') {
          this.dataSource = new MatTableDataSource([]);
          this.validPermit = false;
          this.validWaiver = false;
          this.valid = false;
          this.searchResult = false;
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
        }
      }
    );

    const date = new Date();
    this.todayDate = moment(new Date(date.toString().substr(0, 16))).format("DD-MMM-YYYY");
    // this.activeRouter.params.subscribe(params => { this.isVillageStaff = params.isVillageStaff == "true" });
  }
  onSubmitSearch1() {
    this.btndisabled = false;
    this.searchForm.value['officerId'] = this.currentUserId;
    this.searchForm.value['currentDate'] = new Date().toLocaleString();
    this.enforcementForm.reset();
    this.officerSearchSearch.searchVehicle(this.searchForm.value).subscribe((res) => {
      if (res && res.validWaiver && res.validPermit == null) {
        res.validWaiver[0].plateNo = res.validWaiver[0].state + '-' + res.validWaiver[0].plateNo;
        this.displayedColumns = ['plateNo', 'createdAt', 'streetNumber', 'street'];
        this.permitMessage = 'VALID WAIVER'
        this.messageWithDate = 'for' + " " + this.todayDate;
        this.searchResult = true;
        this.validWaiver = true;
        this.validPermit = false;
        this.valid = false;
        console.log("VALID WAIVER", res.validWaiver);
        this.dataSource = new MatTableDataSource(res.validWaiver);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      }
      if (res && res.validPermit && (!res.validWaiver || res.validWaiver.length == 0)) {
        var monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

        var d = new Date();
        console.log("The current month is " + monthNames[d.getMonth()]);
        this.displayedPermitColumns = ['plateNo', 'startDate'];
        this.permitMessage = 'VALID PERMIT';
        this.messageWithDate = 'for' + " " + monthNames[d.getMonth()] + " " + d.getFullYear();
        this.searchResult = true;
        this.validPermit = true;
        this.validWaiver = false;
        this.valid = false;
        console.log("VALID PERMIT", res.validPermit);
        let permitData = [];
        let data = {
          plateNo: res.validPermit.state + '-' + res.validPermit.plateNo,
          //state: res.validPermit.state,
          startDate: res.validPermit.startDate
        }
        permitData.push(data);

        this.dataSourcePermit = new MatTableDataSource(permitData);
        this.dataSourcePermit.paginator = this.permitPaginator;
        this.dataSourcePermit.sort = this.sort;
      }

      if (res && res.validPermit && res.validWaiver && res.validWaiver.length != 0) {
        var monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

        var d = new Date();
        console.log("The current month is " + monthNames[d.getMonth()]);
        this.displayedPermitColumns = ['plateNo', 'startDate'];
        this.displayedColumns = ['plateNo', 'createdAt', 'streetNumber', 'street'];
        this.permitMessage = 'VALID PERMIT && WAIVER';
        this.messageWithDate = 'for' + " " + this.todayDate;
        this.searchResult = true;
        this.validPermit = true;
        this.validWaiver = true;
        this.valid = false;
        console.log("VALID PERMIT", res.validPermit);
        let permitData = [];
        let data = {
          plateNo: res.validPermit.state + '-' + res.validWaiver.plateNo,
          // plateNo: res.validPermit.plateNo,
          state: res.validPermit.state,
          startDate: res.validPermit.startDate
        }
        permitData.push(data);

        this.dataSourcePermit = new MatTableDataSource(permitData);
        this.dataSourcePermit.paginator = this.permitPaginator;
        this.dataSourcePermit.sort = this.sort;

        this.dataSource = new MatTableDataSource(res.validWaiver);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      }

      if (res && res.isPermit == false) {
        this.displayedColumns = ['plateNo', 'date', 'createdAt', 'action', 'streetNumber', 'street', 'userName'];
        this.permitMessage = 'No Permit / Waiver'
        this.messageWithDate = 'for' + " " + this.todayDate;
        this.searchResult = true;
        this.validPermit = false;
        this.validWaiver = false;
        this.valid = true;
        this.enforcementData = res.enforcementData ? res.enforcementData : null;
        if (res && res.enforcementData.length != 0) {
          res.enforcementData.forEach((element, i) => {
            console.log(element.states.state + '-' + element.plateNo);
            res.enforcementData[i].plateNo = element.states.state + '-' + element.plateNo;
          });
        }
        this.enforcementData = this.enforcementData.sort((a, b) => {
          return <any>new Date(b.date) - <any>new Date(a.date);
        });
        // var today = new Date().toDateString;
        // var reqDateVar = new Date(this.enforcementData[0].date).toDateString;

        // let currentDateWithAction = this.enforcementData.filter(f=>(new Date(f.date).setHours(0,0,0,0)) == new Date().setHours(0,0,0,0,) && f.action);
        // if(this.enforcementData){
        //   this.enforcementData.forEach(element => {
        //     var today = new Date();
        //     today.setHours(0, 0, 0, 0);
        //     d = new Date(element.date); 
        //     d.setHours(0, 0, 0, 0);


        //   });
        // }

        // if(currentDateWithAction){
        //   this.enforcementForm.controls['actionId'].disable({ onlySelf: false, emitEvent: false });
        // }

        //  if(this.enforcementData.date && this.enforcementData.date == new Date()){
        //     console.log('sameDate',this.enforcementData.date == new Date());
        //  }

        const note = this.actions.filter(s => s.action == 'Note');
        console.log(this.actions, 'actionss')
        // const indexOne = this.actions.find(s => s.index == 1);
        const warning = this.actions.filter(s => s.action == 'Warning');
        const citation = this.actions.filter(s => s.action == 'Citation');
        // if (this.enforcementData.length != 0) {
        //   this.actions.map((actionid, inx) => {
        //     this.enforcementData.map(enf => {
        //       if (enf.action != null && actionid.id == enf.actionId && actionid.index == enf.action.index) {
        //         this.enforcementForm.controls.actionId.patchValue(this.actions[inx + 1].id);
        //       }
        //     })
        //   })
        const noteAction = this.enforcementData.filter(s => s.action.id == note[0].id);
        const warningAction = this.enforcementData.filter(s => s.action.id == warning[0].id);
        const citationAction = this.enforcementData.filter(s => s.action.id == citation[0].id);
        if (noteAction.length == 0 && warningAction.length == 0 && citationAction.length == 0) {
          this.enforcementForm.controls.actionId.patchValue(note[0].id);
        }
        if (noteAction.length != 0 && warningAction.length == 0 && citationAction.length == 0) {
          this.enforcementForm.controls.actionId.patchValue(warning[0].id);
        }
        if (noteAction.length != 0 && warningAction.length != 0 && citationAction.length == 0) {
          this.enforcementForm.controls.actionId.patchValue(citation[0].id);
        }
        if (noteAction.length != 0 && warningAction.length != 0 && citationAction.length != 0) {
          this.enforcementForm.controls.actionId.patchValue(citation[0].id);
        }
        if (noteAction.length == 0 && warningAction.length != 0 && citationAction.length == 0) {
          this.enforcementForm.controls.actionId.patchValue(citation[0].id);
        }
        if (noteAction.length == 0 && warningAction.length == 0 && citationAction.length != 0) {
          this.enforcementForm.controls.actionId.patchValue(note[0].id);
        }
        // } else {
        //   this.enforcementForm.controls.actionId.patchValue(indexOne.id);
        // }
        console.log("enforcementData", res.enforcementData);
        this.dataSource = new MatTableDataSource(res.enforcementData);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      }

    });
  }


  onSubmitSearch() {
    this.searchForm.value['officerId'] = this.currentUserId;
    this.officerSearchSearch.searchVehicle(this.searchForm.value).subscribe((res) => {
      console.log(res, 'ressss');
      this.permitMessage = res.isPermit;
      this.displayedColumns = ['plateNo', 'date', 'createdAt', 'action', 'streetNumber', 'street', 'userName'];
      if (res) {
        this.searchResult = true;

        if (this.permitMessage != 'VALID WAIVER' && this.permitMessage != 'VALID PERMIT') {
          this.valid = true;
          // this.vovSharedService.fetchAllEnforcement().subscribe((res)=>{
          if (res && res.enforcementData.length != 0) {
            res.enforcementData.forEach((element, i) => {
              console.log(element.states.state + '-' + element.plateNo);
              res.enforcementData[i].plateNo = element.states.state + '-' + element.plateNo;
            });
            this.enforcementData = res.enforcementData;
            console.log(this.enforcementData);
            this.dataSource = new MatTableDataSource(this.enforcementData);
            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.sort;
            // });

            const note = this.actions.filter(s => s.action == 'Note');
            const warning = this.actions.filter(s => s.action == 'Warning');
            const citation = this.actions.filter(s => s.action == 'Citation');
            const noteAction = this.enforcementData.filter(s => s.action.id == note[0].id);
            const warningAction = this.enforcementData.filter(s => s.action.id == warning[0].id);
            const citationAction = this.enforcementData.filter(s => s.action.id == citation[0].id);
            if (noteAction.length == 0 && warningAction.length == 0 && citationAction.length == 0) {
              this.enforcementForm.controls.actionId.patchValue(note[0].id);
            }
            if (noteAction.length != 0 && warningAction.length == 0 && citationAction.length == 0) {
              this.enforcementForm.controls.actionId.patchValue(warning[0].id);
            }
            if (noteAction.length != 0 && warningAction.length != 0 && citationAction.length == 0) {
              this.enforcementForm.controls.actionId.patchValue(citation[0].id);
            }
          }
          else {
            this.displayedColumns = ['plateNo', 'date', 'createdAt', 'action', 'streetNumber', 'street', 'userName'];
            this.dataSource = new MatTableDataSource([]);
          }

        } else {
          // this.displayedColumns = [];
          this.displayedColumns = ['plateNo', 'createdAt', 'streetNumber', 'street'];
          this.officerSearchSearch.getEnforcemnetWaiver(this.searchForm.value).subscribe((res) => {
            if (res) {
              this.vehicleData = res.vehicle.waiver_vehicle[0].vehicle_details;
              this.vehicleData.forEach(element => {
                element['plateNo'] = res.vehicle.plateNo;
                element['state'] = res.vehicle.states.state;
              });
              this.searchResult = true;
              this.valid = false;
            }
            this.vehicleData.forEach((element, i) => {
              console.log(element.state + '-' + element.plateNo);
              this.vehicleData[i].plateNo = element.state + '-' + element.plateNo;
            });
            this.dataSource = new MatTableDataSource(this.vehicleData);
            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.sort;
            // });
          })

        }
      } else {
        this.displayedColumns = ['plateNo', 'date', 'createdAt', 'action', 'streetNumber', 'street', 'userName'];
      }
    });
  }

  onSubmitEnforcement(formDirective: FormGroupDirective,) {
    this.searchForm.value['officerId'] = this.currentUserId;
    this.searchForm.value['currentDate'] = new Date().toLocaleString();
    this.officerSearchSearch.searchVehicle(this.searchForm.value).subscribe((res) => {
      if ((res.validWaiver || res.validPermit) && res.isPermit) {
        this._snackBar.open('Plate number already has a  valid waiver / permit', '', {
          duration: 3000,
          horizontalPosition: 'right',
          panelClass: 'warning-snackbar'
        });

      } else {
        this.btndisabled = true;
        this.displayedColumns = [];
        this.displayedColumns = ['plateNo', 'date', 'createdAt', 'action', 'streetNumber', 'street', 'userName'];
        this.enforcementForm.value['officerId'] = this.currentUserId;
        this.enforcementForm.value['plateNo'] = this.searchForm.value.plateNo;
        this.enforcementForm.value['stateId'] = this.searchForm.value.stateId;

        this.officerSearchSearch.createEnforcementDetails(this.enforcementForm.value).subscribe((res) => {
          console.log('...................', res);
          this.vovSharedService.fetchAllEnforcement(this.searchForm.value).subscribe((res) => {
            res.enforcementData.forEach((element, i) => {
              var today = new Date();
              today.setHours(0, 0, 0, 0);
              let d = new Date(element.date);
              d.setHours(0, 0, 0, 0);
              if (today == d) {
                console.log(element);
              }
              console.log(element.states.state + '-' + element.plateNo);
              res.enforcementData[i].plateNo = element.states.state + '-' + element.plateNo;
            });
            this.enforcementData = res.enforcementData;
            this.dataSource = new MatTableDataSource(this.enforcementData);
            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.sort;
          });
          // this.enforcementData.map((data: any) => {
          //   let enf = {
          //     plateNo: data.plateNo,
          //     state: data.states.state,
          //     officerId: data.user.userName,
          //     dateIssued: data.date,
          //     streetNo: data.streetNumber,
          //     street: data.streets.street,
          //     action: data.action.action
          //   }
          //   this.enforcement.push(enf)
          // })
          this._snackBar.open('Success :' + res.message, '', {
            duration: 3000,
            horizontalPosition: 'right',
            panelClass: 'success-snackbar'
          });

          formDirective.resetForm();
          this.enforcementForm.reset();
          this.reset();
          this.searchForm.get('plateNo').setValue('');
          this.formGroupDirective.resetForm();

          // this.vovSharedService.fetchAllStates().subscribe((res) => {
          //   this.states = res.statesList;

          // });
          // this.searchForm.get('plateNo').setValue('');
          // this.searchForm.controls['plateNo'].clearValidators();
          // this.searchForm.controls['plateNo'].updateValueAndValidity();
          // this.searchForm.updateValueAndValidity();

        }, error => {
          const errorMessage = error.error.message;
          this._snackBar.open('Warning :' + errorMessage, '', {
            duration: 5000,
            horizontalPosition: 'right',
            panelClass: 'warning-snackbar'
          });
          // formDirective.resetForm();
          // this.enforcementForm.reset();
        });
        console.log(this.enforcementForm.value);
      }
    })
  }

  // exportAsXLSX() {
  //   this.excelService.exportAsExcelFile(this.enforcement, 'sample');
  // }
  ngAfterViewInit() {

  }

  // radioChecked(id, i){
  //   this.enforcementData.forEach(item=>{
  //     if(item && item.action && item.action.id !== id){ 
  //        item.selected = false;
  //     }else{
  //        item.selected = true;
  //     } 
  //   })
  // }


  reset() {
    this.searchResult = false;
    this.vovSharedService.fetchAllStates().subscribe((res) => {
      this.states = res.statesList;
      const toSelect = this.states.filter(s => s.state == 'IL');
      if (toSelect) {
        this.searchForm.get("stateId").patchValue(toSelect[0].id);
      }
    });
    //   // this.searchForm.get('plateNo').setValue('');
    //   // // this.searchForm.controls['plateNo'].clearValidators();
    //   // // this.searchForm.controls['plateNo'].updateValueAndValidity();
    //   // this.searchResult = false;
    //   // const toSelect = this.states.filter(s => s.state == 'IL');
    //   // this.searchForm.get('stateId').setValue(toSelect[0].id);
    //   // if (toSelect) {
    //   //   this.searchForm.get("stateId").patchValue(toSelect[0].id);
    //   // }
  }

} 
